import { RoleDetails } from '../../models/User'

export const getRoleDisplayName = (role: RoleDetails) => {
  const { name, id } = role
  const { displayName } = getRoleMetadata(role)
  return displayName ?? name ?? id
}

const getRoleMetadata = (role: RoleDetails) => {
  const { metadata } = role
  if (!metadata) {
    return {}
  }

  try {
    return JSON.parse(metadata) ?? {}
  } catch (e) {}
}
